import * as sharedConstants from '@/../shared-constants/map-constants';
import AudioFile from '@/../audio/Camera Snap Photo.mp3';
import {
  AlertMsgSnapshotTaken,
  AlertMsgZoningInProcess,
} from '@/alert-string-constants';
import { MapboxInstanceMgr } from '@/map/map-instance';
import { toaster } from '@/utils/toaster';

// TODO: Remove if unused. Add to MapInstanceMgr otherwise
const toggleZoningLayerOpacity = (hasZoningFile) => {
  if (!hasZoningFile || !MapboxInstanceMgr.isReady) {
    toaster.info(AlertMsgZoningInProcess);
    return;
  }
  const mapboxInstance = MapboxInstanceMgr.getInstance().mapInstance;
  const zoningFillLayers = mapboxInstance
    .getStyle()
    .layers.filter((layer) => layer.id.includes('ZONING_FILE_FILL'));
  const zoningLineLayers = mapboxInstance
    .getStyle()
    .layers.filter((layer) => layer.id.includes('ZONING_FILE_LINE'));

  const currentOpacity = mapboxInstance.getPaintProperty(
    zoningFillLayers[0].id,
    'fill-opacity'
  );

  if (currentOpacity === 0) {
    zoningFillLayers.forEach((layer) => {
      mapboxInstance.setPaintProperty(
        layer.id,
        'fill-opacity',
        sharedConstants.DEFAULT_FILL_OPACITY
      );
    });
    zoningLineLayers.forEach((layer) => {
      mapboxInstance.setPaintProperty(
        layer.id,
        'line-opacity',
        sharedConstants.DEFAULT_LINE_OPACITY
      );
    });
  } else {
    zoningFillLayers.forEach((layer) => {
      mapboxInstance.setPaintProperty(layer.id, 'fill-opacity', 0);
    });
    zoningLineLayers.forEach((layer) => {
      mapboxInstance.setPaintProperty(layer.id, 'line-opacity', 0);
    });
  }
};

// TODO: Remove if unused. Add to MapInstanceMgr otherwise
const mapSnapshotCallback = (map) => {
  // TODO: remove map
  const canvas = map.getCanvas();
  const dataUrl = canvas.toDataURL('image/png');
  const mapSnapshotHyperlink = document.createElement('a');
  mapSnapshotHyperlink.href = dataUrl;
  mapSnapshotHyperlink.download = 'image.png';
  mapSnapshotHyperlink.click();
  const snapshotAudio = new Audio(AudioFile);
  snapshotAudio.play();
  toaster.success(AlertMsgSnapshotTaken);
};

// TODO: Remove if unused. Add to MapInstanceMgr otherwise
const refocusBtnCallback = (city, map) => {
  const { max_lnglat, min_lnglat } = city; // eslint-disable-line
  map.flyTo({
    center: [
      (max_lnglat[0] + min_lnglat[0]) / 2,
      (max_lnglat[1] + min_lnglat[1]) / 2,
    ],
    essential: true,
    zoom: 12.8, // aribitrary value, based on my experience
  });
};

// TODO: Remove if unused. Add to MapInstanceMgr otherwise
const mapInfoButtonCallback = (setShowMapInfoModal) =>
  setShowMapInfoModal(true);

export {
  mapSnapshotCallback,
  refocusBtnCallback,
  toggleZoningLayerOpacity,
  mapInfoButtonCallback,
};
